import { Moment } from 'moment';
import { NotificationType } from './enumerations/notification-type.model';

export interface INotification {
  id?: number;
  date?: string;
  details?: string;
  sentDate?: string;
  notificationType?: NotificationType;
  userId?: number;
  productId?: number;
}

export const defaultValue: Readonly<INotification> = {};
